module.exports = __webpack_public_path__ + "img/aParty_111223_F.ba0115a2.jpg";